import angular from 'angular';

function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('stationType', {
    url: '/stationType',
    templateProvider: () =>
      import(/* webpackChunkName: "stationType" */ './stationType.pug').then(
        ({ default: tpl }) => tpl,
      ),
    controller: 'stationTypeCtrl as vm',
    requiredPermission: 'stationType',
    resolve: {
      loadCtrl: $ocLazyLoad =>
        Promise.all([
          import(/* webpackChunkName: "stationType" */ './stationType.controller'),
          import('../../extensions/init/ag-grid'),
          import('../../extensions/directives/select2'),
        ]).then(([module]) => {
          $ocLazyLoad.load({ name: module.name });
          return module.controller;
        }),
    },
  });
}

export default angular.module('app.stationType.routing', []).config(routes);
